import { render } from "./MSidebarSection.vue?vue&type=template&id=15109b94&scoped=true"
import script from "./MSidebarSection.vue?vue&type=script&lang=js"
export * from "./MSidebarSection.vue?vue&type=script&lang=js"

import "./MSidebarSection.vue?vue&type=style&index=0&id=15109b94&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15109b94"]])

export default __exports__